/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Pulse_BodyInputs */



/**
* | output |
* | --- |
* | "Eight signals read every week against your last eight weeks, with the next step when one moves." |
*
* @param {Features_Pulse_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_pulse_body = /** @type {((inputs?: Features_Pulse_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Pulse_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Каждую неделю восемь показателей сравниваются с последними восемью неделями, а когда один из них меняется, вы видите следующий шаг.")
	return /** @type {LocalizedString} */ ("Eight signals read every week against your last eight weeks, with the next step when one moves.")
});